import type { Column } from "@/types/array.types";
import type { Database } from "@/types/database.types";
import type { SortOption } from "../../view-model/viewModel";
import { formatDateDisplay } from "@/utils/date";

export type JewelryType = Database["public"]["Tables"]["jewelry"]["Row"];
export type JewelryInsert = Database["public"]["Tables"]["jewelry"]["Insert"];
export type JewelryUpdate = Database["public"]["Tables"]["jewelry"]["Update"];

type JewelryWithImage = JewelryType & {
    imageUrl?: string;
  };

export const columns = [
    {
        key: "document_id", 
        label: "Photo",
        render: (row) => (
            row.imageUrl 
              ? <img src={row.imageUrl} className="table-image" />
              : "-"
          )
    }, 
    {
        key: "brand", 
        label: "Marque",
        render: (row) => row.brand == null ? "" : row.brand
    }, 
    {
        key: "type", 
        label: "Type",
        render: (row) => row.type == null ? "" : row.type
    }, 
    {
        key: "description", 
        label: "Description", 
        render: (row) => row.description == null ? "" : row.description}, 
    {
        key: "price", label: "Prix",  
        validate: (value) => {
            if (value && isNaN(Number(value))) {
            return "Le prix doit être un nombre.";
            }
            return null;
        },
        render: (row) => row.price ? <div className="table-price-column">{new Intl.NumberFormat("it-IT").format(row.price)} €</div> : ""
    }, 
    {
        key: "at_monaco", 
        label: "Monaco", 
        render: (row) => row.at_monaco ? "Oui" : "Non"}, 
    {key: "at_bank", label: "Banque", render: (row) => row.at_bank ? "Oui" : "Non"}, 
    {
        key: "date", 
        label: "Date", 
        validate: (value) => {
            return value && isNaN(Date.parse(String(value)))
              ? "La date est invalide."
              : null;
          },
        render: (row) =>
        formatDateDisplay(row.date),
        renderLabel: (row) =>  row?.creation_date && formatDateDisplay(new Date(row.creation_date))
    },
    {key: "comment", label: "Commentaire", render: (row) => row.comment == null ? "" : row.comment},
    {key: "id", label: "id"}
] satisfies Column<JewelryWithImage>[];

export const filters = [
    {key: "brand", label: "Marque"},
    {key: "type", label: "Type"}, 
    {key: "at_monaco", label: "Monaco", render: (row) => row.at_monaco ? "Oui" : "Non", renderLabel: (option) => option == "true" ? "Oui" : "Non"}, 
    {key: "at_bank", label: "Banque", render: (row) => row.at_bank ? "Oui" : "Non", renderLabel: (option) => option == "true" ? "Oui" : "Non"}, 
] satisfies Column<JewelryType>[];

export const sortOptions = [
    {
        key: "brand",
        label: "Par marques",
        by: "croissant"
    },
    {
        key: "price",
        label: "Prix croissant",
        by: "croissant"
    },
    {
        key: "price",
        label: "Prix décroissant",
        by: "décroissant"
    },
    {
        key: "created_at",
        label: "Plus récent",
        by: "décroissant"
    },
    {
        key: "created_at",
        label: "Plus ancien",
        by: "croissant"
    },
] as SortOption[];

export const columnsExport = [
    {
        key: "document_id", 
        label: "Photo",
         render: (row) => row.imageUrl ?? "",
    }, 
    {
        key: "brand", 
        label: "Marque",
        render: (row) => row.brand == null ? "" : row.brand
    }, 
    {
        key: "type", 
        label: "Type",
        render: (row) => row.type == null ? "" : row.type
    }, 
    {
        key: "description", 
        label: "Description", 
        render: (row) => row.description == null ? "" : row.description}, 
    {
        key: "price", label: "Prix",  
        render: (row) => row.price ? `${new Intl.NumberFormat("fr-FR").format(row.price).replace(/\u202F/g, " ")} €` : ""
    },
    {
        key: "at_monaco", 
        label: "Monaco", 
        render: (row) => row.at_monaco ? "Oui" : "Non"}, 
    {key: "at_bank", label: "Banque", render: (row) => row.at_bank ? "Oui" : "Non"}, 
    {
        key: "date", 
        label: "Date", 
        render: (row) => {
            return row.date ? new Intl.DateTimeFormat("fr-FR", { dateStyle: "short" }).format(
            new Date(row.date) 
          ) : ""
    }},
    {key: "comment", label: "Commentaire", render: (row) => row.comment == null ? "" : row.comment},
] satisfies Column<JewelryWithImage>[];

export * from "./Jewelry"
